import PrevCharts from "./graph/First/PrevCharts";
import StatusChart from "./graph/StatusChart";
import Category from "./graph/Category";
import OST from "./graph/OSTChart";
import OstManaged from "./graph/OSTManagedChart";
import Syphilis from "./graph/Syphilis";
import TB from "./graph/TBCharts";
import Referral from "./graph/Referral";
import ServicesChart from "./graph/NACPCharts";
import PlhivChart from "./graph/Plhiv";
import Qs from "./graph/Officials";
import Meet from "./graph/Meet";
import EIDCharts from "./graph/Eid";
import CRG from "./graph/CRG";
import MonCharts from "./graph/MonitoringChart";
import Evths1 from "./graph/Evths1";
import Evths2 from "./graph/Evths2";
import Evths3 from "./graph/Evths3";
import Evths4 from "./graph/Evths4";
import Evths5 from "./graph/Evths5";
import Evths6 from "./graph/Evths6";
import Evths7 from "./graph/Evths7";
import Evths8 from "./graph/Evths8";
import StaticStatusChart from "./graph/First/StaticStatusChart";
import ANCPrevCharts from "./graph/First/ANCPrev";
import PWTestingCharts from "./graph/First/PWTesting";
import PWEstimation from "./graph/First/PWEstimation";
import Estimated from "./graph/First/EstimatedPLHIV";
import EstimatedCLHIV from "./graph/First/EstimatedCLHIV.";
import EstimatedYears from "./graph/First/EstimatedYears";
import ARDCharts from "./graph/First/ARD";
import EvthsCharts from "./graph/First/Evths";
import VTRate from "./graph/First/VTRate";
import Support from "./graph/Support";
import Status from "./graph/Status";
import District from "./graph/First/DistrictPrevalence";
import StaticCategory from "./graph/First/Category";
import Evth_new from "./graph/Evths_new";

const ChartContainer = ({ id, data, filters, selectedState }) => {
  if (!id) return null;

  const fp = { filters, selectedState };

  switch (id) {
    case 101:
      return <PrevCharts data={data} />;
    case 102:
      return <ANCPrevCharts data={data} />;
    case 104:
      return <PWTestingCharts data={data} />;
    case 105:
      return <PWEstimation data={data} />;
    case 106:
      return <Estimated data={data} />;
    case 107:
      return <EstimatedCLHIV data={data} />;
    case 108:
      return <EstimatedYears data={data} />;
    case 109:
      return <ARDCharts data={data} />;
    case 1010:
      return <EvthsCharts data={data} />;
    case 1011:
      return <VTRate data={data} />;
    case 1012:
      return <StaticStatusChart data={data} />;
    case 2:
      return <StatusChart data={data} {...fp} />;
    case 3:
      return <Category data={data} {...fp} />;
    case 4:
      return <ServicesChart data={data} {...fp} />;
    case 5:
      return <OST data={data} {...fp} />;
    case 6:
      return <OstManaged data={data} {...fp} />;
    case 7:
      return <Referral data={data} {...fp} />;
    case 8:
      return <Syphilis data={data} {...fp} />;
    case 9:
      return <PlhivChart data={data} {...fp} />;
    case 10:
      return <TB data={data} {...fp} />;
    case 111:
      return <Evths1 data={data} {...fp} />;
    case 112:
      return <Evths2 data={data} {...fp} />;
    case 113:
      return <Evths3 data={data} {...fp} />;
    case 114:
      return <Evths4 data={data} {...fp} />;
    case 115:
      return <Evths6 data={data} {...fp} />;
    case 116:
      return <Evths5 data={data} {...fp} />;
    case 117:
      return <Evths7 data={data} {...fp} />;
    case 118:
      return <Evths8 data={data} {...fp} />;
    case 119:
      return <Evth_new data={data} {...fp} />;
    case 12:
      return <EIDCharts data={data} {...fp} />;
    case 13:
      return <CRG data={data} {...fp} />;
    case 14:
      return <MonCharts data={data} {...fp} />;
    case 15:
      return <Qs data={data} {...fp} />;
    case 16:
      return <Meet data={data} {...fp} />;
    case 17:
      return <Status data={data} {...fp} />;
    case 18:
      return <Support data={data} {...fp} />;
    case 103:
      return <District data={data} />;
    case 1013:
      return <StaticCategory data={data} />;
    default:
      return <p>No chart available</p>;
  }
};

export default ChartContainer;
